import { exists } from '@/api'

export interface BatchTrcBooksAndAvUpdateCondition {
  startNumFrom: string
  startNumTo: string
  searchType: string
  isReplaceAuthority: boolean
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  memo: string
}

export function BatchTrcBooksAndAvUpdateConditionFromJSON(
  json: any
): BatchTrcBooksAndAvUpdateCondition {
  const _json = JSON.parse(json)

  return {
    startNumFrom: exists(_json, 'start_num_from') ? _json.start_num_from : '',
    startNumTo: exists(_json, 'start_num_to') ? _json.start_num_to : '',
    searchType: exists(_json, 'search_type') ? _json.search_type : 'T',
    isReplaceAuthority: exists(_json, 'is_replace_authority')
      ? _json.is_replace_authority
      : false,
    convertHyoukiToFull: exists(_json, 'convert_hyouki_to_full')
      ? _json.convert_hyouki_to_full
      : false,
    convertKanaToHalf: exists(_json, 'convert_kana_to_half')
      ? _json.convert_kana_to_half
      : false,
    memo: exists(_json, 'memo') ? _json.memo : ''
  }
}
